import React from 'react';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import {
  PACKAGE_CHANGE_TYPES,
  TYPE_POPUP_MIGRATE,
} from '@src/constants/package';
import {
  checkCustomPackage,
  getPackageChangeType,
  getPackageNameV3,
} from '@src/services/package';
import { useSelector } from 'react-redux';
import sanitizeHtml from 'sanitize-html';
import { StyledDialogUpDownGradeV3 } from '../../index.style';
import Content from './Content';

const PopupNoticeRolloverOrder = ({
  typeCheckUpDownGradePackV3,
  creditsOrderData,
}) => {
  const { usingPackage } = useSelector((state) => state.user);
  const { user } = useSelector((state) => state.auth);
  const { package: packageState } = useSelector((state) => state.order);
  const { t, i18n } = useTranslation();
  const { language } = i18n;

  const packageName = (pack) =>
    getPackageNameV3(pack?.name, pack?.code, language, t);

  const packageChangeType = getPackageChangeType({
    currPackage: packageState,
    prevPackage: usingPackage,
    prevPackageExpiredDate: user?.packageExpiryDate,
  });
  const isDowngrade = packageChangeType === PACKAGE_CHANGE_TYPES.DOWNGRADE;
  const isCustomPackage = checkCustomPackage({
    level: usingPackage.level,
    type: usingPackage.type,
  });

  const isBuyingCustomPackage = checkCustomPackage({
    level: packageState.level,
    type: packageState.type,
  });

  const levelText = () => {
    if (isDowngrade || isCustomPackage) return t('downV2');

    return t('changeV2');
  };

  const Title = () => {
    let key = 'certainBenefitPlanWillRemain';
    const oneTimePackage =
      TYPE_POPUP_MIGRATE.TYPE_MIGRATE_V1_V2_TO_V3 ===
      typeCheckUpDownGradePackV3;

    if (oneTimePackage) key = 'certainBenefitsOldPlanWillRemain';
    if (isDowngrade && !isCustomPackage) key = 'allBenefitsPlanWillBeLost';
    if (isCustomPackage && !isBuyingCustomPackage)
      key = 'certainBenefitPlanWillBeLost';

    return (
      <Typography
        className="info-package-mirgate"
        component="span"
        dangerouslySetInnerHTML={{
          __html: t(key, {
            packageName: packageName(usingPackage),
          }),
        }}
      />
    );
  };

  return (
    <StyledDialogUpDownGradeV3>
      <div className="content-wrapper">
        <div className="content">
          <Title />
          {((packageChangeType && packageState?.cycle) ||
            (isCustomPackage && packageState?.cycle) ||
            (usingPackage?.cycle && !packageState?.cycle)) && (
            <div
              className="sub-title"
              component="span"
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{
                __html: t('changeFromPackageTitleV2', {
                  prefix: levelText(),
                  fromPackage: packageName(usingPackage),
                  toPackage: packageName(packageState),
                }),
              }}
            />
          )}
          <Content
            usingPackage={usingPackage}
            packageState={packageState}
            creditsOrderData={creditsOrderData}
            typeCheckUpDownGradePackV3={typeCheckUpDownGradePackV3}
          />
          <div className="support-payment">
            <Typography
              component="span"
              dangerouslySetInnerHTML={{
                __html: sanitizeHtml(t('supportPayment'), {
                  allowedTags: ['a'],
                  allowedAttributes: {
                    a: ['href', 'target', 'rel', 'data-id', 'style'],
                  },
                }),
              }}
            />
          </div>
        </div>
      </div>
    </StyledDialogUpDownGradeV3>
  );
};

export default PopupNoticeRolloverOrder;
